/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, { useState, useEffect, useContext } from "react";
import {
  UmbracoContext,
  UmbracoStep,
} from "../../../components/Umbraco/UmbracoContext";
import {
  LabelTitle,
  Label,
  Line,
  Row,
  ButtonNext,
  ButtonPrev,
  InnerMedium,
} from "meitav-uikit";
import QuestionFooter from "./QuestionFooter";
import Sectors from "../../SectorType/SectorIndex";
import utils from "../../../utils";
import PopUpBitcoin from "../../Lobby/components/PopupBitcoin";

import { Parser as HtmlToReactParser } from "html-to-react";
const htmlToReactParser = new HtmlToReactParser();

const { rest, UmbracoUtills } = utils;

export default function Question8(props) {
  const { stepActive, anserOld, riskLevel, resourceIcon, setNextDisabled } =
    props;
  const [selectedItem, setSelectedItem] = useState("");
  const [open, setOpen] = useState(false);
  const htmlToReactParser = new HtmlToReactParser();
  const resource = UmbracoStep(
    useContext(UmbracoContext).resource,
    "Question8"
  );
  const resourcePopUp = UmbracoStep(
    useContext(UmbracoContext).resource,
    "PopUpBitcoin"
  );
  const investPolicyGUID = localStorage.getItem("investPolicyGUID");

  useEffect(() => {}, []);

  const sectorChange = (obj) => {
    if (obj.code == 6 && riskLevel < 5) {
      setOpen(true);
      setNextDisabled(true);
    } else {
      const action_name8 = `אפיק ההשקעות שבחרתי- ${obj.name}`;
      window.dataLayer.push({
        event: "PM - sector",
        eventInfo: {
          action_screen: window.location.pathname,
          sectorCode: obj.code,
          process_level: "בחירת אפיק השקעה",
          action_name: action_name8,
        },
      });
      props.changeAnswerFunc(stepActive, obj.code, "", obj.name);
      setNextDisabled(false);
    }
  };
  const changeProfile = async () => {
    window.dataLayer.push({
      event: "PM - ivestment",
      eventInfo: {
        action_screen: window.location.pathname,
        process_level: "הרכב תיק ההשקעות",
        action_name: "אישור שינוי הרכב התיק",
      },
    });

    const result = await rest.get(
      `/api/Manager/ChangeUserPorfile?guid=${investPolicyGUID}`
    );
    window.open(`/CustomerInvestPolicy`, "_self");
  };
  return (
    <div className="sectorQuestion">
      <LabelTitle type="title">
        {htmlToReactParser.parse(
          UmbracoUtills.getValueByKey(resource, "title")
        )}{" "}
      </LabelTitle>

      <Label>
        {htmlToReactParser.parse(UmbracoUtills.getValueByKey(resource, "text"))}
      </Label>

      <div className="sectorItemList list">
        <Sectors
          anserOld={anserOld}
          sectorOnChange={sectorChange}
          textRecommended={UmbracoUtills.getValueByKey(resource, "markInfo")}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          mode={"list"}
          riskLevel={riskLevel}
        />
      </div>
      <QuestionFooter
        icon={UmbracoUtills.getValueByKey(resourceIcon, "icon")}
        iconUp={UmbracoUtills.getValueByKey(resourceIcon, "iconUp")}
        iconDown={UmbracoUtills.getValueByKey(resourceIcon, "iconDown")}
        whyImportant={UmbracoUtills.getValueByKey(resource, "whyImportant")}
        tooltip={UmbracoUtills.getValueByKey(resource, "tooltip")}
      />
      <PopUpBitcoin
        openProp={open}
        setOpen={setOpen}
        okBtnClick={changeProfile}
        icon={"restartIcon"}
        resourceText={UmbracoUtills.getValueByKey(resourcePopUp, "text")}
        changeProfileBtn={UmbracoUtills.getValueByKey(
          resourcePopUp,
          "changeProfile"
        )}
        changeAfikBtn={UmbracoUtills.getValueByKey(resourcePopUp, "changeAfik")}
      />
    </div>
  );
}
